
const qiniu: any = require("qiniu-js");
import { Request } from "@/api/request";
import { defineComponent, ref, inject, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { getQiNiuYunToken } from "@/api/http";
export default defineComponent({
    name: "EditProjectType",
    setup() {
        const Router = useRouter();
        const Route = useRoute();
        const setTitle: any = inject("setTitle"),
            headClass = inject("headClass");
        setTitle(["服务管理", "服务分类", "编辑"]);

        let form: any = ref({
                img: "",
                img1: "",
                simg: "",
                simg1: "",
                name: "",
                sort: "",
            }),
            formRef: any = ref(null),
            tableData = ref([] as any),
            loading = ref(true);
        const validatorImg = (value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请上传选中图标"));
                }
            },
            validatorImg1 = (value: string, callback: Function) => {
                if (value) {
                    callback();
                } else {
                    callback(new Error("请上未选中图标"));
                }
            };
        const rules: any = ref({
            img: [
                {
                    required: true,
                    validator: (
                        rule: any,
                        value: string,
                        callback: Function
                    ) => {
                        validatorImg(form.value.simg, callback);
                    },
                    trigger: "blur",
                },
            ],
            img1: [
                {
                    required: true,
                    validator: (
                        rule: any,
                        value: string,
                        callback: Function
                    ) => {
                        validatorImg1(form.value.simg, callback);
                    },
                    trigger: "blur",
                },
            ],
            simg: [
                {
                    required: true,
                    validator: (
                        rule: any,
                        value: string,
                        callback: Function
                    ) => {
                        validatorImg(form.value.simg, callback);
                    },
                    trigger: "blur",
                },
            ],
            simg1: [
                {
                    required: true,
                    validator: (
                        rule: any,
                        value: string,
                        callback: Function
                    ) => {
                        validatorImg1(form.value.simg, callback);
                    },
                    trigger: "blur",
                },
            ],
        });
        // 上传图片功能
        let token = "",
            bucketURL = "",
            uploadImg = (file: any) => {
                return new Promise((resolve: any, rejetc) => {
                    let config = {
                        useCdnDomain: true,
                        // region: qiniu.region.z2,
                    };
                    let putExtra = {
                        fname: "",
                        params: {},
                        mimeType: null,
                    };
                    let observable: any = {};

                    observable = qiniu.upload(
                        file,
                        null,
                        token,
                        putExtra,
                        config
                    );
                    const observer = {
                        next(res: any) {},
                        error(err: any) {},
                        complete(res: any) {
                            resolve(res);
                        },
                    };
                    observable.subscribe(observer);
                });
            },
            beforeAvatarUpload = (file: File) => {
                const isJPG = file.type === "image/jpeg";
                const isPNG = file.type === "image/png";
                if (!isJPG && !isPNG) {
                    ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                }
                return isJPG && isPNG;
            },
            handleChange = (file: any,key:string) => {
                uploadImg(file.raw).then((res: any) => {
                    form.value[key] = bucketURL + res.key;
                });
            };
        // 获取项目列表
        let onSubmit = () => {
            (formRef.value as any).validate((valid: boolean) => {
                if (valid) {
                    let data = {},
                        url = "";
                    // if (dialogType.value == 1) {
                    //     url = "adminapi/VipClass/create";
                    //     data = form.value;
                    // } else {
                    //     url = "adminapi/VipClass/edit";
                    //     data = {
                    //         class_id: form.value.class_id,
                    //         class_name: form.value.class_name,
                    //     };
                    // }
                    Request.axiosInstance({
                        url: "adminapi/ProjectType/edit",
                        data: form.value,
                    }).then((res: any) => {
                        if (res.status == 202) {
                            Router.go(-1)
                        }
                    });
                }
            });
        };

        onMounted(() => {
            Request.axiosInstance({
                url: "adminapi/ProjectType/info",
                data: { id: Route.query.id },
            }).then((res: any) => {
                loading.value = false;
                if (res.status == 200) {
                    Object.keys(form.value).forEach((key: string) => {
                        form.value[key] = res.content.list[key];
                    });
                    form.value["id"] = res.content.list.id;
                }
            });
            getQiNiuYunToken().then((res: any) => {
                token = res.content.token;
                bucketURL = res.content.domain;
            });
        });

        return {
            headClass,
            form,
            formRef,
            rules,
            tableData,
            onSubmit,
            loading,
            beforeAvatarUpload,
            handleChange,
        };
    },
});
